export const TEST_ATTR = "data-test";
export const TEST_VALUE_ATTR = "data-test-value";
export const TEST_PROP = "testName";
export const TEST_VALUE_PROP = "testValue";

export interface IE2EOpts {
  id?: number | string;
  sufix?: string;
}

export interface ITestable {
  [TEST_PROP]?: string;
  [TEST_VALUE_PROP]?: string | number;
}
